import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { productCategories } from '../data/mock';

const ProductsSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="products" className="py-16 lg:py-24 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-sm font-semibold text-[#2563eb] bg-white px-4 py-1.5 rounded-full mb-4">
              Our Products
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#1e1919] mb-4">
              Products & Solutions
            </h2>
            <p className="text-[#736c64] max-w-xl">
              Explore our range of computers, printers, accessories, and electronics from trusted brands. Visit our store for the best deals and expert advice.
            </p>
          </div>
          <Button
            variant="outline"
            className="border-[#2563eb] text-[#2563eb] hover:bg-[#2563eb] hover:text-white self-start lg:self-auto"
            onClick={scrollToContact}
          >
            Enquire Today
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productCategories.map((category, index) => (
            <Card
              key={category.id}
              className="group overflow-hidden border-0 bg-white shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e1919]/80 via-[#1e1919]/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white mb-1">{category.title}</h3>
                </div>
              </div>
              <CardContent className="p-5">
                <p className="text-[#736c64] text-sm mb-4 line-clamp-2">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {category.items.slice(0, 3).map((item, idx) => (
                    <span
                      key={idx}
                      className="text-xs bg-[#f7f5f2] text-[#2563eb] px-2.5 py-1 rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                  {category.items.length > 3 && (
                    <span className="text-xs bg-[#2563eb]/10 text-[#2563eb] px-2.5 py-1 rounded-full">
                      +{category.items.length - 3} more
                    </span>
                  )}
                </div>
                <button
                  onClick={scrollToContact}
                  className="inline-flex items-center text-sm font-medium text-[#2563eb] hover:text-[#1d4ed8] transition-colors group/btn"
                >
                  Enquire Now
                  <ChevronRight className="w-4 h-4 ml-1 group-hover/btn:translate-x-1 transition-transform" />
                </button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Info Banner */}
        <div className="mt-12 bg-white rounded-2xl p-6 lg:p-8 flex flex-col lg:flex-row items-center justify-between gap-6 border border-[#2563eb]/10">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-xl bg-[#2563eb]/10 flex items-center justify-center">
              <span className="text-2xl">💻</span>
            </div>
            <div>
              <h4 className="font-semibold text-[#1e1919]">Looking for something specific?</h4>
              <p className="text-sm text-[#736c64]">Visit our store or call us for product availability and custom orders</p>
            </div>
          </div>
          <Button
            className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white px-6"
            onClick={scrollToContact}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
